import React from "react";
import RightPanel from "../../../common/rightPanel/RightPanel";
import DocumentVersionRow from "./DocumentVersionRow";
import { Box, SxProps, Theme } from "@mui/material";
import * as api from "../../../../api/generated-api";
import { format } from "date-fns";
import DocumentActions from "../DocumentActions";

type Props = {
  dealDocumentVersions: api.DealDocumentVersion[];
  selectedVersion: number;
  onVersionSelect: (version: number) => void;
  onSignaturesClick: () => void;
};

const DocumentVersionsSidebar = ({
  dealDocumentVersions,
  selectedVersion,
  onVersionSelect,
  onSignaturesClick,
}: Props) => {
  const innerContainer: SxProps<Theme> = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  };

  const documentVersionsContainer: SxProps<Theme> = {
    flex: 9,
    overflowY: "auto",
    maxHeight: "80vh",
  };

  return (
    <RightPanel title="Versions">
      <Box sx={innerContainer}>
        <Box sx={documentVersionsContainer}>
          {dealDocumentVersions
            .sort((a, b) => b.version - a.version)
            .map((dealDocumentVersion, index) => {
              const formattedDate = format(
                new Date(dealDocumentVersion.createdAt),
                "MMMM dd, yyyy • h:mm a"
              );

              const { firstName, lastName } =
                dealDocumentVersion.creator.person;

              return (
                <DocumentVersionRow
                  key={index}
                  version={dealDocumentVersion.version}
                  name={`${firstName} ${lastName}`}
                  date={formattedDate}
                  sourceExtension={dealDocumentVersion.sourceExtension}
                  selected={dealDocumentVersion.version === selectedVersion}
                  onClick={() => {
                    onVersionSelect(dealDocumentVersion.version);
                  }}
                ></DocumentVersionRow>
              );
            })}
        </Box>
        <DocumentActions onSignaturesClick={onSignaturesClick} />
      </Box>
    </RightPanel>
  );
};

export default DocumentVersionsSidebar;
